import classnames from "classnames";
import React, { ReactNode } from "react";

interface IProps {
  children: ReactNode;
  className?: string;
}

const Row = ({ children, className }: IProps): JSX.Element => {
  return <div className={classnames("row", className)}>{children}</div>;
};

export default Row;
